var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('task',{attrs:{"type":9,"keyID":"9B742AFA55B88E9B1BC3AD7A5802FBFA"}})}
var staticRenderFns = []

export { render, staticRenderFns }